import { Form, Formik } from 'formik';
import React, { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import * as Yup from 'yup';

import Button from '@components/Button';
import TextField from '@components/FormFields/TextField';
import useCorporateLeadCreate from '@hooks/useCorporateLeadCreate';
import useServerSideRendering from '@hooks/useServerSideRendering';
import { RAILS_ENV, RECAPTCHA_SITE_KEY } from '@src/env';

import styles from './styles.module.scss';

const schema = () =>
  Yup.object().shape({
    email: Yup.string().email().required('Email is Required'),
  });

const FooterSection = () => {
  const { mutate: createCorporateLead } = useCorporateLeadCreate(true);
  const reCaptchaRef = useRef<ReCAPTCHA>();
  const handleSubmit = async ({ email }) => {
    try {
      const refToken = RAILS_ENV === 'test' ? '' : await reCaptchaRef.current.executeAsync();
      createCorporateLead({ corporate_lead: { email, recaptcha_token: refToken } });
    } catch (e) {
      console.error('catching error: ', e);
    }
    reCaptchaRef.current.reset();
  };
  const hydrated = useServerSideRendering();

  return (
    <div className={styles.footerContainer} id="footerContainer">
      <div className="container">
        <div className={styles.footerWrapper}>
          <div className={styles.footerHeader}>Get in Contact</div>
          <div className={styles.footerSubheader}>
            Find out how a Group Subscription can impact your business.
          </div>
          {hydrated && (
            <ReCAPTCHA sitekey={RECAPTCHA_SITE_KEY} size="invisible" ref={reCaptchaRef}>
              <Formik
                validationSchema={schema}
                initialValues={{ email: '' }}
                onSubmit={async (values, { resetForm }) => {
                  await handleSubmit(values);
                  resetForm();
                }}
              >
                {(formik) => (
                  <Form onSubmit={formik.handleSubmit}>
                    <div className={styles.footerFormContainer}>
                      <TextField name="email" placeholder="Enter your email" />
                      <Button variant="primary" type="submit">
                        CONTACT US
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </ReCAPTCHA>
          )}
          <div className={styles.emailContactWrapper}>
            <div className={styles.emailContact}>
              If you are interested in content distribution or partnerships, please contact{' '}
              <a href="mailto:corporate@theinformation.com">corporate@theinformation.com</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterSection;
